import { render, staticRenderFns } from "./template2.vue?vue&type=template&id=91f05328&"
import script from "./template2.vue?vue&type=script&lang=js&"
export * from "./template2.vue?vue&type=script&lang=js&"
import style0 from "./template2.vue?vue&type=style&index=0&id=91f05328&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91f05328')) {
      api.createRecord('91f05328', component.options)
    } else {
      api.reload('91f05328', component.options)
    }
    module.hot.accept("./template2.vue?vue&type=template&id=91f05328&", function () {
      api.rerender('91f05328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/renovation/template2.vue"
export default component.exports